import initVideo from "./initVideo";
import mobileHeader from "./mobileHeader";
import addPlaceHolders from "./placeholders";
import slider from "./slider";
import sliderModal from "./sliderModal";
import tabs from "./tabs";
import videoModal from "./video";

import { vote, checkForDisabledBtns} from "./vote";

document.addEventListener('DOMContentLoaded', function() {
    slider();
    addPlaceHolders();
    videoModal();
    tabs();
    sliderModal();
    mobileHeader();
    initVideo();
    checkForDisabledBtns();
    vote();
})